import { BaseRequestModel } from '../../../base/base.request.model';

export class RefreshTokenRequestModel extends BaseRequestModel {
  refreshToken!: string;
}
